import { useFormikContext } from "formik";
import React, { FC, useState } from "react";
import { useLocale } from "../../../contexts/localeContext";
import { TableContextProvider } from "../../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { WizardStepLayout } from '../../wizard/wizard-summary-layout';
import AccessGroupColumns from "../../../models/ColumnDefinitions/AccessGroupColumns";
import AccessGroupSearch from "../../../models/search/AccessGroupSearch";
import { removeColumns } from "../../../models/utilities/columnHelper";
import { getAllAccessGroups } from "../../../services/accessGroupService";
import TableTab from "../../tabs/table-tab";

interface FloorGroupStepProps {
    onNext: (e: any) => void;
    onBack: (e: any) => void;
    setTotalFloorGroups: React.Dispatch<React.SetStateAction<number>>;
}

const FloorGroupStep: FC<FloorGroupStepProps> = ({ onNext, onBack, setTotalFloorGroups }) => {
    const { setFieldValue, values } = useFormikContext<any>();
    const { translate } = useLocale();
    const [selectedIds, setSelectedIds] = useState<string[]>([]);
    const [selectedRows, setSelectedRows] = useState<any[]>([]);

    const onLocalNext = (e: any) => {
        setTotalFloorGroups(selectedIds.length);
        setFieldValue("floorGroups", selectedIds);
        setFieldValue("floorGroupRows", selectedRows);
        onNext(e);
    }

    const hasAtLeastOneSelection = selectedIds.length > 0 || (values.accessGroups && values.accessGroups.length > 0);

    return <WizardStepLayout onBack={onBack} onNext={onLocalNext} nextDisabled={!hasAtLeastOneSelection}>
        <div className="overflow-y-auto" style={{ height: '87%' }}>
            <TableContextProvider
                dataMethod={(listParameters) => getAllAccessGroups(2, translate, listParameters)}
                tableDescriptor={removeColumns(AccessGroupColumns, ['days', 'startTime', 'duration', 'enrolments', 'accessProfile'])}
                searchDescriptor={AccessGroupSearch}
                useTable
                usePagination
                useFilter
                useSearch
                useSort>
                <TableTab
                    title={translate.byKey(TranslationKeys.floorGroups)}
                    selectRows={true}
                    selectedIds={selectedIds}
                    setSelectedIds={setSelectedIds}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    cyName="floorGroupStep"/>
            </TableContextProvider>
        </div>
    </WizardStepLayout>
}

export default FloorGroupStep;